import { TranslateModule } from '@ngx-translate/core';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BixLoaderComponent } from './bix-loader.component';



@NgModule({
  declarations: [BixLoaderComponent],
  imports: [
    CommonModule,
    TranslateModule
  ],
  exports:[
    BixLoaderComponent
  ]
})
export class BixLoaderModule { }
